<template>
    <v-container fluid id="outline" class="py-15">
        <v-container grid-list-xl>
            <v-layout v-bind="binding">
                <v-flex xs12 sm4 offset-sm-1 class="text-left">
                    <h2 class="font-weight">
                        OUTLINE
                    </h2>
                    <div class="mx-auto mt-6">
                        <h3 class="text-body-1 font-weight-bold">{{$t("LP.outline.name")}}</h3>
                        <p class="mt-2 text-pre-wrap text-body-1" v-html="$t('LP.outline.name_text')"></p>
                    </div>
                    <div class="mx-auto mt-5">
                        <h3 class="text-body-1 font-weight-bold">{{$t("LP.outline.term")}}</h3>
                        <p class="mt-2 text-pre-wrap text-caption" v-html="$t('LP.outline.term_text')"></p>
                    </div>
                    <div class="mx-auto mt-6">
                        <h3 class="text-body-1 font-weight-bold">{{$t("LP.outline.time")}}</h3>
                        <p class="mt-2 text-pre-wrap text-caption" v-html="$t('LP.outline.time_text')"></p>
                    </div>
                    <div class="mx-auto mt-6">
                        <h3 class="text-body-1 font-weight-bold" v-html="$t('LP.outline.place')"></h3>
                        <p class="mt-2 text-pre-wrap text-caption" v-html="$t('LP.outline.place_text')"></p>
                    </div>
<!--                     <div class="mx-auto mt-6">
                        <h3 class="text-body-1 font-weight-bold" v-html="$t('LP.outline.price')"></h3>
                        <v-btn :href="tickets" v-smooth-scroll class="mt-4 text-pre-wrap" rounded light>
                            {{$t('LP.outline.price_text')}}<span class="icon arrow size-1"></span></v-btn>
                    </div> -->
                    <div class="mx-auto mt-8">
                        <h3 class="text-body-1 font-weight-bold">{{$t("LP.outline.contact")}}</h3>
                        <p class="mt-2 text-pre-wrap text-caption" v-html="$t('LP.outline.contact_text')"></p>
                        <a class="mt-2 text-decoration-underline text-caption" :href="$t('LP.outline.terms_url')" v-html="$t('LP.outline.terms')" target="_blank"></a>
                        <a class="mt-2 text-decoration-underline d-block text-caption" :href="$t('LP.outline.conditions_url')" v-html="$t('LP.outline.conditions')" target="_blank"></a>
                        <p class="mt-6 text-pre-wrap text-caption" v-html="$t('LP.outline.operating')"></p>
                    </div>
                </v-flex>
                <v-flex xs12 sm6 class="text-left">
                    <h2 class="font-weight">
                        ACCESS
                    </h2>
                    <a :href="$t('LP.access.link')" class="access-map" target="_blank">
                        <v-img class="mt-6 link-map" :href="$t('LP.access.link')" :src="$t('LP.access.map')">
                        </v-img>
                    </a>
                    <!-- <p class="caption mt-6">{{$t("LP.access.caption")}}</p> -->
                    <!-- <v-row align="center" class="mt-6">
                        <v-col cols="12" md="3">
                            <h3 class="text-body-1 font-weight-bold">{{$t("LP.access.parking")}}</h3>
                        </v-col>
                        <v-col cols="12" md="9">
                            <v-btn rounded light>{{$t("LP.access.parking_button")}}<span
                                        class="icon arrow size-1"></span></v-btn>
                        </v-col>
                    </v-row> -->
                    <v-row class="mt-6">
                        <v-col cols="12" sm="6" class="text-caption">
                            <dt>{{$t("LP.access.train_dt")}}</dt>
                            <dd class="text-pre-wrap" v-html="$t('LP.access.train_dd')"></dd>
                        </v-col>
                        <v-col cols="12" sm="6" class="text-caption order-sm-2">
                            <dt>{{$t("LP.access.bus_dt")}}</dt>
                            <dd class="text-pre-wrap" v-html="$t('LP.access.bus_dd')"></dd>
                        </v-col>
                        <v-col cols="12" sm="6" class="text-caption order-sm-1">
                            <dt>{{$t("LP.access.car_dt")}}</dt>
                            <dd class="text-pre-wrap" v-html="$t('LP.access.car_dd')"></dd>
                        </v-col>

                    </v-row>
                </v-flex>
            </v-layout>
        </v-container>
    </v-container>
</template>

<script>
    export default {

        computed: {
            binding() {
                const binding = {}

                if (this.$vuetify.breakpoint.xsOnly) binding.column = true

                return binding
            },
        },

        data: () => ({
            tickets: '#tickets',
        })
    }
</script>

<style lang="scss">
    /* ACCESS MAP */

    .access-map {
        .link-map {
            position: relative;
            z-index: 1;

            &::before {
                position: absolute;
                content: 'MAPを開く';
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                font-size: 1rem;
                padding: .2em 1em;
                max-width: 170px;
                border: 1px solid #000;
                border-radius: 30px;
                background: #fff;
                color: #000;
                z-index: 2;
            }

            &:hover {
                opacity: .8;
            }
        }
    }
</style>